import React from 'react'
import PropTypes from 'prop-types'
import FlexRow from '../../../../../molecules/FlexRow'
import OpalHeading from '../../../../../opal/OpalHeading'
import AIEnabledTag from '../../shared/AIEnabledTag'
import DeprecatedTag from '../../shared/DeprecatedTag'
import SystemTag from '../../shared/SystemTag'
import InternalTag from '../../shared/InternalTag'
import AlwaysAvailableTag from '../../shared/AlwaysAvailableTag'

function DatasourceHeader ({ datasource }) {
  return (
    <div>
      <FlexRow className='gap-md'>
        <OpalHeading className='font-size-lg'>{datasource.displayName}</OpalHeading>
        {datasource.isSystem ? (
          <SystemTag />
        ) : null}
        {datasource.isInternal ? (
          <InternalTag />
        ) : null}
        {datasource.isAiEnabled ? (
          <AIEnabledTag />
        ) : null}
        {datasource.isAlwaysAvailable ? (
          <AlwaysAvailableTag />
        ) : null}
        {datasource.isDeprecated ? (
          <DeprecatedTag />
        ) : null}
      </FlexRow>
      <FlexRow>
        <OpalHeading className='font-size-xs'>{datasource.code}</OpalHeading>
      </FlexRow>
    </div>
  )
}

DatasourceHeader.propTypes = {
  datasource: PropTypes.shape({
    displayName: PropTypes.string,
    code: PropTypes.string,
    isAiEnabled: PropTypes.bool,
    isDeprecated: PropTypes.bool,
    isSystem: PropTypes.bool,
    isInternal: PropTypes.bool,
    isAlwaysAvailable: PropTypes.bool
  })
}

export default DatasourceHeader
